import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useGoPathAfterRender = (path: string, condition: boolean) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (condition) {
      navigate(path, { replace: true });
    }
  }, [condition, navigate]);
};

export default useGoPathAfterRender;
